import script from "./ScriptEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./ScriptEdit.vue?vue&type=script&setup=true&lang=js"

import "./ScriptEdit.vue?vue&type=style&index=0&id=923ee46a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-923ee46a"]])

export default __exports__